import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../store/auth';

/** Gate for super-admin-only routes (e.g. Platform). Nested inside RequireAuth, so
 * identity is already resolved; a non-admin is bounced to their own landing. */
export default function RequireAdmin() {
  const me = useAuth((s) => s.me);
  if (me?.role !== 'admin') return <Navigate to="/stores" replace />;
  return <Outlet />;
}
